import { render, staticRenderFns } from "./solutionSafety.vue?vue&type=template&id=276c4f16&scoped=true&"
import script from "./solutionSafety.vue?vue&type=script&lang=js&"
export * from "./solutionSafety.vue?vue&type=script&lang=js&"
import style0 from "./solutionSafety.vue?vue&type=style&index=0&id=276c4f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276c4f16",
  null
  
)

export default component.exports